import { combineReducers } from 'redux';
import { reducer_availableExtraServices } from '../component/data/availableExtraServices';
import { reducer_selectedExtraServices } from '../component/data/selectedExtraServices';

export const base = 'extraServices';

export default combineReducers({
  availableExtraServices: reducer_availableExtraServices,
  selectedExtraServices: reducer_selectedExtraServices,
});
